<template>
  <div class="Actvas">
    <div class="Actvas-background">
      <div class="appHelmetysen">商场活动<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="Actvas-actity">
        <img :src="actyls.IMAGE_URL" alt="">
        <div class="Actvas-actity-conten">
          <p class="Actvas-actity-conten-left-test">{{actyls.NAME}}</p>
          <p class="Actvas-actity-conten-left-time">活动时间: {{actyls.STATE_DATE}} -- {{actyls.END_DATE}}</p>
        </div>
      </div>
      <div class="Actvas-detals">
        <p class="Actvas-detals-title">活动详情</p>
        <div class="Actvas-detals-rext" v-html="actyls.HTML_CONTENT"></div>
        <!-- <p class="Actvas-detals-text">建议参加年龄段: 7-10岁</p>
        <p class="Actvas-detals-text">每张券仅限一位会员参加</p>
        <p class="Actvas-detals-text">集体活动,请勿迟到</p>
        <p class="Actvas-detals-text Actvas-detals-time">活动时间: 11.27  10:30</p>
        <img src="../../public/obraoag/acvils.png" alt="">
        <p class="Actvas-detals-title Actvas-detals-actyes">活动规则</p>
        <p class="Actvas-detals-text Actvas-detals-rule">- 请于所选活动时间前往6F一茶一舍集合,核销使用;</p>
        <p class="Actvas-detals-text Actvas-detals-rule">- 七宝万科广场会员线上抢兑名额,每张券限1人参加;</p>
        <p class="Actvas-detals-text Actvas-detals-rule">- 数量有限,抢完为止,兑换成功后不予退还;</p>
        <p class="Actvas-detals-text Actvas-detals-rule">- 如遇个人原因无法参加活动,活动电子券可线上转赠;</p>
        <p class="Actvas-detals-text Actvas-detals-rule">- 本活动为集体活动,请勿迟到</p>
        <p class="Actvas-detals-text Actvas-detals-rule">* 报名成功后请勿缺席,多次缺席将失去活动报名资格</p>
        <p class="Actvas-detals-title Actvas-detals-actyes">报名说明</p>
        <p class="Actvas-detals-text Actvas-detals-rule">报名要求: 报名需扣减200积分</p>
        <p class="Actvas-detals-text Actvas-detals-rule">报名条件: 限金卡Plus,黑卡Plus会员参与。</p> -->
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      acavid: '',
      actyls: ''
    }
  },
  created(){
    // 接收商场列表传过来的ID
    this.acavid = this.$route.query.shavid;
    // 商场活动详情
    this.$axios.post('app/mallActivityObj',this.$qs.stringify({
      ID: this.acavid
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.actyls = res.data;
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Actvas.css";
</style>